import MojitoCore from 'mojito/core';
import NeutralVenueIndicatorImpl from './neutral-venue-indicator';

const { UIView } = MojitoCore.Presentation;

/**
 * `NeutralVenueIndicator` shows the neutral event icon when provided event is taking place at a neutral venue.
 *
 * @class NeutralVenueIndicator
 * @memberof Mojito.Presentation.Components
 */

export default UIView('NeutralVenueIndicator', NeutralVenueIndicatorImpl);
